export const LAST_DIGITS_NUMBER = 4;
export const TRAVELER_V1_API_URL_KEY = 'homeApiUrl';
export const TRAVELER_V2_API_URL_KEY = 'travelerApiUrl';
export const TRAVELER_V1_API_ENDPOINT = '/travel/home/v1/traveler';
export const TRAVELER_V2_API_ENDPOINT = '/travel/v2/travel_services/traveler/details';
export const TRAVELER_V1_CLIENT_ID_ONLINE = '684C957199C3BE6C153A778D1986032B';
export const TLS_ONLINE_CLIENT_ID = 'TLSONLINE';
export const HIPED_ENC_TYPE = 'ENC_HIPED';
